import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { referralApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { storeRef } from '../utils/referralRef';

// /r/:code — an agent's link. The server remembers the first link this browser followed
// (an HttpOnly cookie), then the person goes on to sign up. Signed-in users just go home.
const ReferralLinkPage = () => {
  const { code } = useParams();
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
      return;
    }
    let done = false;
    const go = () => {
      if (!done) {
        done = true;
        navigate('/register', { replace: true });
      }
    };
    referralApi.click(code).then((r) => storeRef(r.data?.ref)).catch(() => {}).finally(go);
    const timer = setTimeout(go, 4000); // never keep a visitor waiting on a slow answer
    return () => clearTimeout(timer);
  }, [code, isAuthenticated, loading, navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress aria-label="Загрузка" />
    </Box>
  );
};

export default ReferralLinkPage;
